import { full } from './shared/routes/full.routes';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from './shared/components/layout/full/full.component';
import { content } from "./shared/routes/routes";

const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));

const routes: Routes = [
  {
    path: '',
    redirectTo: isMobile ? 'evento/inicio' : 'evento/inicio', //'inicio',
    pathMatch: 'full'
  },
  {
    path: '*/:id',
    redirectTo: 'evento/inicio',
    pathMatch: 'full'
  },
  {
    path: '',
    component: ContentComponent,
    children: content
  },
  {
    path: '',
    component: FullComponent,
    children: full
  },
  {
    path: '**',
    redirectTo: isMobile ? 'evento/inicio' : 'evento/inicio' //'inicio'
  }
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
